export const PRIMARY_COLOR = "#A30523";
export const TEXT_PRIMARY = "#333333";
export const TEXT_SECONDARY = "#444444";
export const BACKGROUND_DARK = "#111111";
export const BACKGROUND_SEMI_DARK = "#222222";
export const NEUTRAL_LIGHT = "#D9D9D9";
export const NEUTRAL_DARK = "#2A2A2A";
export const SURFACE_LIGHT = "#ECECEC";
export const MAX_WIDTH = "90rem";
export const SIDE_PADDING = {
  xs: "1.25rem",
  md: "3rem",
  xl: "5rem",
} as const;
export const HEADER_HEIGHT = "4.75rem";
export const TOP_PADDING = `calc(${HEADER_HEIGHT} + 1rem)`;
export const SUBMENU_HEIGHT = "3.75rem";
export const DEFAULT_TRANSITION = "all 0.3s ease";
